import { TrivialError } from 'app/core/error/error';
import { Globals } from 'app/core/globals';
import { ConditionConfig } from 'collage-designer/collage-designer-config';
import { DesignStepService
       } from 'collage-designer/design-step/design-step.service';

export class InvalidConditionError extends TrivialError
{
  protected _name: string = 'InvalidConditionError';
}

export class ConditionMatcher
{
  private catalogStoreId: string;
  private designStepService: DesignStepService;

  public constructor(catalogStoreId: string,
                     designStepService: DesignStepService)
  {
    this.catalogStoreId = catalogStoreId;
    this.designStepService = designStepService;
  }

  public async areConditionFullfilled(conditions: Array<ConditionConfig>
                                      ): Promise<boolean>
  {
    for (const c of conditions) {
      if (!await this.isConditionFullfilled(c)) {
        return false;
      }
    }
    return true;
  }

  private async isConditionFullfilled(condition: ConditionConfig
                                      ): Promise<boolean>
  {
    let pattern = undefined;
    const partId = condition.part;

    switch (condition.type) {
      case 'part_is_landscape':
        return (await this.getPartOrientation(partId)) === 'landscape';
      case 'part_is_portrait':
        return (await this.getPartOrientation(partId)) === 'portrait';
      case 'store_matches':
        pattern = new RegExp(condition.value.replace('*', '.*'));
        return pattern.test(this.catalogStoreId);
      case 'store_does_not_match':
        pattern = new RegExp(condition.value.replace('*', '.*'));
        return !pattern.test(this.catalogStoreId);
      case 'mode_is':
        return condition.value === Globals.mode;
      case 'is_available':
        return condition.value === 'yes';
      case 'product_id_contains':
        return this.designStepService.getProductId().includes(condition.value);
      case 'product_id_not_contains':
        return !this.designStepService.getProductId().includes(condition.value);
      default:
        throw new InvalidConditionError(`condition ${condition.type} unknown`);
    }
  }

  private async getPartOrientation(partId: string): Promise<string|undefined>
  {
    const structure = await this.designStepService.getSVGStructureByPartId(
        partId);
    if (!structure) {
      return undefined;
    }

    const doc = (new DOMParser()).parseFromString(structure, 'image/svg+xml');
    const width =
        parseFloat((<HTMLElement> doc.firstChild).getAttribute('width'));
    const height =
        parseFloat((<HTMLElement> doc.firstChild).getAttribute('height'));

    return width > height ? 'landscape' : 'portrait';
  }
}
